<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id" :initialAttr="attr">
        <div :class="['label-tab', attr.header_cssClass]" v-if="attr && parent_type !== 'AttrTabPanel' && attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</div>
        <div
            :class="'attrs ' + attr['cssClass']"
            v-if="attr && (attr.visible !== undefined ? attr.visible : true)"
            :style="attr.cssStyle || 'flex-direction:row;'"
        >
            <component v-for="attrC in attr.attrs"
                :widget_id="widget_id"
                :key="attrC.html_id"
                :is="attrC.component"
                :attr_id="attrC.id"
                v-bind="childParentAttr(attrC) ? { parentAttr: childParentAttr(attrC) } : {}"
            />
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

export default {
    props: {
        widget_id: [String, Number],
        attr_id: String,
        parent_type: String,
        initialAttr: {
            type: Object,
            default: null,
        },
        parentAttr: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        WIDGET: {},
        attr: null,        // в data — реактивная смена объекта вкладки (initialAttr)
        parent_attr: null,
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        content_Changed() {
            if (this.initialAttr && (this.store.tabs_noId || this.attr_id == null)) {
                // вкладка передана объектом (tabs_noId) — поиск по id не нужен
                this.attr = this.initialAttr
                this.parent_attr = this.parentAttr
            } else {
                this.store.widget_attr_set(this)
            }
        },
        childParentAttr(attrC) {
            // структурный родитель — только компонентам, пишущим hide/countItems вкладки
            return ['AttrGrid', 'AttrTabGrid', 'AttrStrMulti', 'AttrMD'].includes(attrC.component) ? this.attr : null
        },
    },
    watch: {
        initialAttr(attr) {
            // пересборка view заменила объект вкладки — подхватываем без поиска
            if (attr && (this.store.tabs_noId || this.attr_id == null)) {
                this.attr = attr
                this.parent_attr = this.parentAttr
            }
        },
    },
}
</script>

<style>
.attrs {
    width:-webkit-fill-available;
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap; */
}
.label-attr {
    font-size: 0.875rem;
    top: 4px;
    color: #3f51b5;
    margin-left: 20px;
}
.label-tab {
    font-size: 0.875rem;
    text-transform: uppercase;
    font-weight: bold;
    border-bottom: 2px solid #77889923;
    top: 4px;
    color: #778899;
    padding: 8px 12px 8px 12px;
    margin-bottom: 8px;
}
.header-1 {
    background: #f2f5f5;
}

</style>